import { container } from "setup/dependency/inversify.config";
import { IAuthenticationService } from "services/AuthenticationService";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { IClientPortalUsersService } from "services/ClientPortalUsersService";
import { ImpersonationTokenModel } from "services/api/cplauthapi/CPLAuthAPI";

export function login(companyID: string, email: string, password: string, oneTimePassword?: string) {
  const authenticationService = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
  return authenticationService.logIn(companyID, email, password, oneTimePassword);
}

export async function resetPassword(email: string) {
  const clientPortalUsersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
  await clientPortalUsersService.resetPassword(email);
}

export function getUserProfile() {
  const clientPortalUsersService = container.get<IClientPortalUsersService>(SERVICE_TYPES.ClientPortalUsersService);
  return clientPortalUsersService.getProfile();
}

export async function logout() {
  const authenticationService = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
  await authenticationService.logOut();
}

export async function verifyImpersonatedUser(verificationCode: string, token: ImpersonationTokenModel) {
  const impersonationService = container.get<IAuthenticationService>(SERVICE_TYPES.AuthenticationService);
  return impersonationService.logInAsImpersonatedUser(verificationCode, token);
}
